import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleOAuthLogin = async () => {
    setLoading(true);
    setError('');

    try {
      // Check if user explicitly logged out (check both storages)
      const requireLogin = localStorage.getItem('explicit_logout') === 'true' || 
                          sessionStorage.getItem('explicit_logout') === 'true';
      
      console.log('🔍 OAuth Login - Force login?', requireLogin);
      
      // Get OAuth authorization URL from backend
      const response = await axios.get('/api/auth/oauth/init', {
        params: { force_login: requireLogin }
      });
      const { authUrl, state } = response.data;

      // Store state for validation (optional - backend handles this)
      sessionStorage.setItem('oauth_state', state);

      // Redirect to Keycloak for authentication
      window.location.href = authUrl;
    } catch (err: unknown) {
      setError(
        axios.isAxiosError<{ message?: string }>(err)
          ? (err.response?.data?.message || 'Failed to initiate login. Please try again.')
          : 'Failed to initiate login. Please try again.'
      );
      setLoading(false);
    }
  };

  const handleContinueAsGuest = () => {
    navigate('/dashboard');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <div className="card" style={{ maxWidth: '450px', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔐</div>
          <h1 style={{ marginBottom: '0.5rem' }}>Sign In</h1>
          <p style={{ color: 'var(--gray-600)' }}>Securely login with Keycloak</p>
        </div>

        {error && (
          <div className="error" style={{ marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={handleOAuthLogin}
          className="btn btn-primary"
          style={{ width: '100%', fontSize: '1.1rem', padding: '1rem' }}
          disabled={loading}
        >
          {loading ? (
            <>
              <span style={{ display: 'inline-block', marginRight: '8px' }}>🔄</span>
              Redirecting...
            </>
          ) : (
            <>
              <span style={{ display: 'inline-block', marginRight: '8px' }}>🚀</span>
              Sign In with Keycloak
            </>
          )}
        </button>

        <div style={{ 
          margin: '1.5rem 0', 
          textAlign: 'center',
          color: 'var(--gray-500)',
          fontSize: '0.875rem'
        }}>
          <p>You will be redirected to Keycloak's secure login page</p>
        </div>

        <button 
          type="button"
          onClick={handleContinueAsGuest}
          className="btn btn-secondary" 
          style={{ width: '100%', marginTop: '1rem' }}
          disabled={loading}
        >
          Continue as Guest
        </button>

        <div style={{ marginTop: '1.5rem', textAlign: 'center', color: 'var(--gray-600)' }}>
          Don't have an account?{' '}
          <Link to="/register" style={{ color: 'var(--primary)', fontWeight: 600 }}>
            Register here
          </Link>
        </div>

        <div style={{ marginTop: '1rem', textAlign: 'center', color: 'var(--gray-600)', fontSize: '0.875rem' }}>
          <Link to="/forgot-password" style={{ color: 'var(--primary)' }}>
            Forgot password?
          </Link>
        </div>
      </div>
    </div>
  );
}
